import { render, staticRenderFns } from "./ProductGroupMatrix.vue?vue&type=template&id=a83cb340&"
import script from "./ProductGroupMatrix.vue?vue&type=script&lang=js&"
export * from "./ProductGroupMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports